import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useFloatingButton = (isLoggedIn) => {
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 767) {
        setShowFloatingButton(true);
      } else if (location.pathname === '/') {
        setShowFloatingButton(window.scrollY > window.innerHeight * 0.5);
      } else {
        setShowFloatingButton(true);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [location.pathname]);

  return !isLoggedIn && showFloatingButton;
};

export default useFloatingButton; 